export enum RoleType {
  User = 'user',
  Patient = 'patient',
}
